document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('bdBlueLightModal');
  if (!modal) return;

  // Move to <body> to avoid stacking-context issues from nested product-form elements
  if (modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }

  var ADDON_VARIANTS = {
    zeiss_blue:   53239478780231,
    plus_blue:    53239473963335,
  };

  // Bei Epos (bzw. Tag "no-plano"): keine Plano-Variante -> Schritt 1 überspringen
  var noPlano = modal.getAttribute('data-bl-no-plano') === 'true';

  var stepChoice  = document.getElementById('bdBlStep1');
  var stepCardsRx = document.getElementById('bdBlStep2Rx');
  var stepNoRx    = document.getElementById('bdBlStep2NoRx');

  var productForm =
    document.querySelector('form[data-type="add-to-cart-form"]') ||
    document.querySelector('product-form form') ||
    document.querySelector('form[action^="/cart/add"]');
  if (!productForm) return;

  var basePrice = modal.dataset.basePrice || '0';
  var summary = window.BdWizSummary && window.BdWizSummary.mount('bdBlueLightModal', basePrice, 'Fassung');

  var selectedLens = null;
  var selectedPrice = '0';
  var selectedAddonVariant = null;

  // --- Steps ---
  function hideAll() {
    [stepChoice, stepCardsRx, stepNoRx].forEach(function(s) {
      if (s) s.style.display = 'none';
    });
  }

  function show(el) {
    hideAll();
    if (el) el.style.display = 'block';
  }

  function openModal() {
    modal.style.display = 'block';
    modal.setAttribute('aria-hidden', 'false');
    resetState();
    if (summary) summary.reset();
    if (bdRxStep) bdRxStep.hide();
    if (noPlano) {
      show(stepCardsRx);
    } else {
      show(stepChoice);
    }
  }

  function closeModal() {
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
  }

  function resetState() {
    selectedLens = null;
    selectedPrice = '0';
    selectedAddonVariant = null;
  }

  // --- Sehstärke übermitteln (shared step) ---
  var bdRxStep = window.BdRxStep && window.BdRxStep.mount({
    prefix: 'bdBlRx',
    onBack: function () { show(stepCardsRx); },
    onComplete: function (rxProps, fileInput) {
      var properties = Object.assign({
        'Gläserpaket': selectedLens,
        'Gläserpaket Aufpreis (CHF)': selectedPrice,
      }, rxProps);
      closeModal();
      window.BdCartEngine.submit({
        productForm: productForm,
        properties: properties,
        fileInput: fileInput,
        addonVariantId: selectedAddonVariant,
      });
    },
  });

  // --- Trigger button ---
  document.querySelectorAll('[data-open-bluelight-modal]').forEach(function(btn) {
    btn.addEventListener('click', function(e) { e.preventDefault(); openModal(); });
  });

  // --- Close on backdrop ---
  modal.addEventListener('click', function(e) {
    if (e.target && e.target.closest && e.target.closest('[data-bd-bl-close]')) closeModal();
  });

  // --- STEP 1: Mit/Ohne Sehstärke (tap-to-advance) ---
  var optRx = document.getElementById('bdBlOptRx');
  if (optRx) optRx.addEventListener('click', function() {
    show(stepCardsRx);
  });

  var optNrx = document.getElementById('bdBlOptNrx');
  if (optNrx) optNrx.addEventListener('click', function() {
    show(stepNoRx);
  });

  // --- STEP 2a: Glasqualität (tap-to-advance) ---
  document.querySelectorAll('#bdBlCardList .bd-wiz-row').forEach(function(row) {
    row.addEventListener('click', function() {
      selectedLens = row.getAttribute('data-bl-lens');
      selectedPrice = row.getAttribute('data-price') || '0';
      selectedAddonVariant = ADDON_VARIANTS[selectedLens] || null;
      if (summary) summary.set('lens', row.getAttribute('data-name') || '', selectedPrice);
      hideAll();
      if (bdRxStep) bdRxStep.show();
    });
  });

  var cardsBack = document.getElementById('bdBlCardsBack');
  if (cardsBack) cardsBack.addEventListener('click', function() {
    if (noPlano) { closeModal(); } else { show(stepChoice); }
  });

  // --- STEP 2b: Blue Control (ohne Sehstärke, kein Rx-Schritt nötig) ---
  var noRxBack = document.getElementById('bdBlNoRxBack');
  if (noRxBack) noRxBack.addEventListener('click', function() { show(stepChoice); });

  var noRxAdd = document.getElementById('bdBlNoRxAdd');
  if (noRxAdd) noRxAdd.addEventListener('click', function() {
    closeModal();
    window.BdCartEngine.submit({
      productForm: productForm,
      properties: {
        'Gläserpaket': 'Blue Control',
        'Gläserpaket Aufpreis (CHF)': '0',
        'Rx Method': 'Ohne Sehstärke',
      },
      fileInput: null,
      addonVariantId: null,
    });
  });
});
